import { Pagination } from '@mui/material';
import React, { useEffect, useState } from 'react'
import loader from '../assets/images/loader.gif'
import axiosClient from '../axios';
import SideBar from './SideBar';
import moment from 'moment';
import { useNavigate } from 'react-router-dom'
import Pagination_2 from './Pagination_2';
import '../assets/css/AdminCommon.css'; // V4 Styles
import { Autocomplete, TextField } from "@mui/material";

const AllVideos = () => {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [allProvider, setAllProvider] = useState([]);
    const [allCountry, setAllCountry] = useState([]);
    const [pagination, setPagination] = useState({
        page: 0,
        limit: 100
    });
    const [countryCode, setCountryCode] = useState("All");

    const navigate = useNavigate();

    const getAllCountry = () => {
        axiosClient
            .get("/getAllCountry")
            .then((res) => {
                console.log("res of all country", res);
                setAllCountry(res?.data?.response);
            })
            .catch((error) => {
                console.log("Error In Getting All Country...");
            });
    };

    const getAllVideos = () => {
        setLoading(true)
        axiosClient
            .get(`/allvideo?country=${countryCode}`)
            .then((res) => {
                setData(res?.data?.response)
                setLoading(false)
            })
            .catch((error) => console.log(error))
            .finally(() => setLoading(false))
    }


    const getPartner = () => {
        axiosClient
            .get("/partnersList")
            .then((res) => setAllProvider(res.data.response))
            .catch((error) => console.log(error));
    }

    const getPartnerName = (partnerId) => {
        let partnerdata = allProvider.find((item) => item._id === partnerId)
        return partnerdata?.name
    }


    let optionsValue = {
        "1": "is profiler",
        "2": "surveydisqualification",
        "3": "surveycomplete",
        "4": "task-games complete",
        "5": "task-games failed",
        "6": "is partner",
        "7": "profiler complete",
        "8": "125 earning not complete 1hour",
        "9": "125 not complete 1 day",
        "10": "How to Do Ptc Video"
    }


    useEffect(() => {
        getAllVideos();
        getPartner();
        getAllCountry();
    }, [])



    return (
        <>
            <SideBar handleSideBar={true} activeTab={"allVideo"} />
            <div className="admin-screen-v4">
                <div className="admin-header-v4">
                    <h2>All Videos</h2>
                    <div className="dFlex" style={{ gap: "16px" }}>
                        <button
                            className="btn-primary-v4"
                            onClick={() => navigate('/videoStat')}
                        >
                            Video Statistics
                        </button>
                        <button
                            className="btn-primary-v4"
                            onClick={() => navigate('/video')}
                        >
                            Add New Video
                        </button>
                        <Autocomplete
                            sx={{ width: 300 }}
                            options={allCountry}
                            value={
                                allCountry.find(
                                    (item) => item.alpha2 === countryCode
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                setCountryCode(newValue?.alpha2 || "");
                            }}
                            getOptionLabel={(option) => option?.name || ""}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Country" />
                            )}
                        />
                        <button onClick={getAllVideos} className='btn-primary-v4'>Search</button>
                    </div>
                </div>

                {!loading ? (
                    <div className="admin-form-container-v4">
                        {data?.length > 0 ? (
                            <>
                                <div className="table-container-v4">
                                    <table className="data-table-v4">
                                        <thead>
                                            <tr>
                                                <th>S.NO.</th>
                                                <th>Provider Name</th>
                                                <th>Trigger Points</th>
                                                <th>Video Link</th>
                                                <th>Hit Number</th>
                                                <th>Daily Limit</th>
                                                <th>Time Gap</th>
                                                <th>Is Active</th>
                                                <th>Skip Status</th>
                                                <th>Skip Time Gap</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((val, key) => (
                                                <tr key={key + 1}>
                                                    <td className="text-muted-v4">{key + 1}</td>
                                                    <td className="text-link-v4">
                                                        {getPartnerName(val?.partnerId) || "—"}
                                                    </td>
                                                    <td>
                                                        <span className="earning-badge-v4 type-1">
                                                            {optionsValue[val?.triggerpoints] || "—"}
                                                        </span>
                                                    </td>
                                                    <td className="text-mono-v4">
                                                        <a
                                                            href={val?.videoLink}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-link-v4"
                                                        >
                                                            {val?.videoLink ? "View Video" : "—"}
                                                        </a>
                                                    </td>
                                                    <td className="amount-v4">
                                                        {val?.hitNumber || "—"}
                                                    </td>
                                                    <td>
                                                        {val?.dailyLimit || "—"}
                                                    </td>
                                                    <td>
                                                        {val?.timeGap || "—"}
                                                    </td>
                                                    <td>
                                                        <span className={`status-badge-v4 ${val?.isActive ? "status-1" : "status-2"
                                                            }`}>
                                                            {val?.isActive ? "Active" : "Inactive"}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`status-badge-v4 ${val?.skipStatus?.isSkip ? "status-1" : "status-4"
                                                            }`}>
                                                            {val?.skipStatus?.isSkip ? "Skippable" : "Non-skippable"}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {val?.skipStatus?.timeGap || "—"}
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="btn-action-table-v4 btn-sm-v4"
                                                            onClick={() => navigate(`/editVideo/${val?._id}`)}
                                                        >
                                                            Edit
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* {data?.length > 0 && (
                                    <div className="pagination-v4">
                                        <div className="pagination-info-v4">
                                            <span>Showing {data?.length} videos</span>
                                            <select 
                                                className="pagination-select-v4"
                                                value={pagination.limit}
                                                onChange={(e) => setPagination({
                                                    ...pagination,
                                                    limit: parseInt(e.target.value),
                                                    page: 0
                                                })}
                                            >
                                                <option value={50}>50 per page</option>
                                                <option value={100}>100 per page</option>
                                                <option value={200}>200 per page</option>
                                            </select>
                                        </div>
                                        <div className="pagination-buttons-v4">
                                            <Pagination_2
                                                filterDataInput={pagination}
                                                setFilterDataInput={setPagination}
                                            />
                                        </div>
                                    </div>
                                )} */}
                            </>
                        ) : (
                            <div className="empty-state-v4">
                                <div className="empty-icon-v4">🎬</div>
                                <h3>No Videos Found</h3>
                                <p>Add your first video to get started</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="loader-container-v4">
                        <img src={loader} alt="Loading..." className="loader-image-v4" />
                    </div>
                )}
            </div>
        </>
    )
}

export default AllVideos
